export interface TabDef {
	id: string;
	label: string;
	/** URL slug — each report is deep-linked at /reports/center/<slug>. */
	slug: string;
	/** Per-tab menu-action code (each tab is a separate, individually granted option). */
	code: string;
}

/** SIMS-8161: the Disbursed Incentives report's tab id. */
export const DISBURSED_TAB_ID = "disbursed";

export const TAB_DEFS: TabDef[] = [
	{
		id: "assistant",
		label: "Assistant",
		slug: "assistant",
		code: "REP_DASH_ASSISTANT_VIEW",
	},
	{
		id: "enrollment",
		label: "Enrollment summary",
		slug: "enrollment",
		code: "REP_DASH_ENROLLMENT_VIEW",
	},
	{
		id: "activity",
		label: "Program Summary",
		slug: "program-summary",
		code: "REP_DASH_ACTIVITY_VIEW",
	},
	{
		id: "visit",
		label: "Visit detail",
		slug: "visit-detail",
		code: "REP_DASH_VISIT_VIEW",
	},
	// SIMS-8161: Disbursed Incentives — its own independently granted option.
	{
		id: DISBURSED_TAB_ID,
		label: "Disbursed Incentives",
		slug: "disbursed-incentives",
		code: "REP_DASH_DISBURSED_VIEW",
	},
];

// Legacy umbrella code: a role that still holds it sees every tab (back-compat
// with the original single Reports Center grant, before per-tab codes existed).
export const UMBRELLA_CODE = "REP_DASH_VIEW";

/**
 * The reports this user may see.
 *
 * Extracted from the dashboard component (SIMS-8161) so the visibility rule is
 * testable on its own rather than only through a full render.
 *
 * **This is a presentation filter, not a security control.** The endpoint behind
 * each report enforces its own menu-action code server-side — for the Disbursed
 * Incentives report that is `assertMenuAction` in `reports.controller.ts`
 * (SECURITY-08). Hiding a tab here keeps the UI honest; it does not protect data.
 */
export const resolveVisibleTabs = (
	userHasAccessToCode: (code: string) => boolean,
): TabDef[] => {
	const hasUmbrella = userHasAccessToCode(UMBRELLA_CODE);
	return TAB_DEFS.filter((t) => hasUmbrella || userHasAccessToCode(t.code));
};
